import React from 'react';
const image = require('./united_tathata.svg');
function UnitedTathataLogo() {
  return <img alt="United + Tathata logo" style={{ width: 360 }} src={image} />;
}
export default UnitedTathataLogo;



// WEBPACK FOOTER //
// ./src/layout/UnitedTathataLogo.js